import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ServiceValues {
  _hasHydrated: boolean;
  removeFix: boolean;
  atTop: boolean;
  isScrolling: boolean;
  scrollYPosition: number;
  scrollDirection: 'up' | 'down' | 'none' | string;
}

const initState: ServiceValues = {
  _hasHydrated: false,
  removeFix: false,
  atTop: true,
  isScrolling: false,
  scrollYPosition: 0,
  scrollDirection: 'none',
};

interface ServiceActions {
  setRemoveFix: (value: boolean) => void;
  setIsScrolling: (value: boolean) => void;
  setScrollYPosition: (value: number) => void;
  getScrollDirection: () => 'up' | 'down' | 'none' | undefined;
}

export type ServiceState = ServiceValues & ServiceActions;

export const navigationService = create<ServiceState>()(
  persist(
    (set, get) => ({
      ...initState,
      setRemoveFix: (removeFix: boolean) => {
        set({ removeFix });
      },
      setIsScrolling: (isScrolling: boolean) => {
        set({ isScrolling });
      },
      setScrollYPosition: (scrollYPosition: number) => {
        set({ atTop: scrollYPosition < 20 });
        set({ scrollYPosition });
      },
      getScrollDirection: (): 'up' | 'down' | 'none' => {
        const scrollY = window.scrollY || document.documentElement.scrollTop;

        if (scrollY > get().scrollYPosition) {
          set({ scrollDirection: 'down' });
          set({ isScrolling: false });
          return 'down';
        }

        if (scrollY < get().scrollYPosition) {
          set({ scrollDirection: 'up' });
          set({ isScrolling: true });
          return 'up';
        }
        return 'none';
      },
    }),
    {
      name: 'navigation-service',
    }
  )
);
